<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        ">
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link class="text-decoration-none router-link" to="/AgenteService">หน้าแรก</router-link>
            </li>
            <li class="breadcrumb-item" aria-current="page">
              <router-link class="text-decoration-none router-link" to="/AgenteService">ข้อมูลยื่นคำร้อง</router-link>
            </li>
            <li class="breadcrumb-item" aria-current="page">
              <router-link class="text-decoration-none router-link"
                to="/AgentInfo">ขอเปลี่ยนแปลงข้อมูลตัวแทน</router-link>
            </li>
            <li class="breadcrumb-item router-link active">ขอบันทึก VAT</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->
  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile -->
      <div class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        " style="background-color: #f2f2f2">
        <div class="icon-back">
          <router-link to="/AgentInfo">
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </router-link>
        </div>
        <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
          style="font-family: DB Heavent; color: #0057a8">
          ขอบันทึก VAT
        </div>
      </div>
      <!-- Mobile -->
      <div class="col">
        <div class="title d-none d-lg-block border-bottom font-family blue-1">
          ขอบันทึก VAT
        </div>
        <div class="pb-3 pb-lg-3 border-bottom font-family fw-normal">
          <div class="mt-4 mt-lg-2">
            <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2">
              ขั้นตอนถัดไปกรุณาเตรียมเอกสารแนบ :
            </div>
          </div>
          <div class="">
            <div class="blue-1 fs-4 d-lg-inline-block mt-lg-2">
              ภ.พ.01 / ภ.พ.20
            </div>
          </div>
        </div>
        <div class="row mb-3 mt-2">
          <div class="col-6 col-lg-6">
            <button type="button" class="btn btn-light btn-cancel font-family d-inline-block" data-bs-toggle="modal"
              data-bs-target="#exampleModal">
              ยกเลิก
            </button>
          </div>
          <div class="col-6 col-lg-6 text-right">
            <router-link to="/AgentInfo">
              <button type="button" class="btn btn-continue font-family d-inline-block" @click="EnterNext()">
                ดำเนินการต่อ
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade font-family" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fs-4" id="exampleModalLabel"></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="icon-model">
            <img src="@/assets/images/icon-warning.svg" class="w-100" />
          </div>
          <div class="massege fw-normal text-center">
            <p class="mb-0">รายการเปลี่ยนแปลงของท่านยังไม่ได้รับ</p>
            <p class="mb-0">การบันทึก และข้อมูลที่ท่านกรอกจะถูกล้าง</p>
            <p class="mb-0 pt-lg-4">
              ท่านต้องการจะย้อนกลับไปก่อนหน้านี้ใช่หรือไม่
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light fw-normal popup_cancel" data-bs-dismiss="modal">
            ไม่ต้องการ
          </button>
          <router-link to="/AgentInfo">
            <button type="button" class="btn btn-model fw-normal" data-bs-dismiss="modal"
              @click="ClearData()">ต้องการ</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
export default {
  name: "EditVat",
  components: {
    Menu,
  },
  data() {
    return {};
  },
  mounted() {
    if (this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }
  },
  methods: {
    EnterNext() {
      this.$store.state.EditAgentInfo.CHANGE_VAT.SUCCESS = true;
    },
    ClearData() {
      this.$store.state.EditAgentInfo.CHANGE_VAT.SUCCESS = false;
    },
  },
};
</script>

<style></style>